import { render, staticRenderFns } from "./VoucherBatchReport.vue?vue&type=template&id=0a46b50c&scoped=true"
import script from "./VoucherBatchReport.vue?vue&type=script&lang=js"
export * from "./VoucherBatchReport.vue?vue&type=script&lang=js"
import style0 from "./VoucherBatchReport.vue?vue&type=style&index=0&id=0a46b50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46b50c",
  null
  
)

export default component.exports